// تسميات عربية مشتركة بين المهام والتذاكر — تُعرَّف مرّة واحدة.
// كانت مكرّرة حرفياً في ١٢ صفحة
// فتباعدت: بعض الصفحات تعرض الأولوية بالعربية وبعضها خاماً بالإنجليزية.

export const STATUS_AR = {
  pending: 'جديدة',
  in_progress: 'قيد العمل',
  waiting_approval: 'بانتظار اعتماد',
  approved: 'معتمدة',
  completed: 'مكتملة',
  revision: 'مراجعة',
  cancelled: 'ملغاة',
};

export const PRIORITY_AR = {
  low: 'منخفضة',
  medium: 'متوسطة',
  high: 'عالية',
  urgent: 'عاجلة',
};

export const STATUS_COLOR = {
  pending: 'var(--text-faint)',
  in_progress: '#3b82f6',
  waiting_approval: '#f59e0b',
  approved: '#8b5cf6',
  completed: '#10b981',
  revision: '#ef4444',
  cancelled: 'var(--text-muted)',
};

export const statusLabel = (s) => STATUS_AR[s] || s;
export const priorityLabel = (p) => PRIORITY_AR[p] || p;
